import * as React from 'react';

import Store from 'logic/local-storage/Store';
import { PaginationProvider, SelectedRowsProvider, ModalProvider } from 'common/contexts';
import useActivePerspective from 'components/perspectives/hooks/useActivePerspective';
import type { SecurityEventAPIType } from 'security-app/hooks/api/securityEventsAPI.types';
import type { ModalTypes } from 'security-app/components/SecurityEvents/Alerts/AlertsModals';
import { LOCAL_STORAGE_ITEM } from 'security-app/hooks/api/securityEventsAPI.types';

import GeneralUI from './GeneralUI';
import SecurityUI from './SecurityUI';
import AlertsModals from './AlertsModals';

function Index() {
  const { activePerspective } = useActivePerspective();
  const isSecurityPerspective = activePerspective.id === 'security';
  const lastSearch = Store.get(LOCAL_STORAGE_ITEM);

  return (
    <PaginationProvider initFilters={lastSearch ? { alerts: lastSearch.alerts, timerange: lastSearch.timerange } : {}}>
      <SelectedRowsProvider<SecurityEventAPIType>>
        <ModalProvider<ModalTypes, SecurityEventAPIType>>
          {isSecurityPerspective ? <SecurityUI /> : <GeneralUI />}
          <AlertsModals />
        </ModalProvider>
      </SelectedRowsProvider>
    </PaginationProvider>
  );
}

export default Index;
